module.exports = "/img/_/_/_/assets/images/creeper/battle/rare//8.jpg?b912488e5444ee51f7d5ae02b05ec506";